import Vue from "vue";
import VueRouter from "vue-router";
import { baseAdminRoute } from "@/router/admin";
import store from "@/store";
import { getPersonRoute as getModularByUserId } from "@/api/new-question-iteration/common";
import NavBar from "@/views/home/NavBar";
import Footer from "@/views/home/Footer";
import { codeMapModules, HOME_PAGE_MAP } from "@/utils/platform-config"
import { Message } from "element-ui";

const {
    "-100": questionLib,
    "-200": exam,
    "-300": course,
    "-400": questionnaire,
    "-500": home,
    "2": profile,
    "3": myCollect,
    "4": myTrack,
    "5": myQuestionnaire,
    "6": myMember,
    "7": myCourse,
    "8": myExam
} = codeMapModules
Vue.use(VueRouter);
// 路由表
const routes = [
    {
        path: "/home-medicine",
        name: "home",
        component: () => import("@/views/home"),
        meta: {
            keepAlive: true, // 需要被缓存
            auth: home.enName
        }
    },
    {
        path: "/home-exam",
        name: "HomeExam",
        components: {
            navBar: NavBar,
            default: () => import("@/views/home/exam"),
            footer: Footer
        },
        meta: {
            keepAlive: true, // 需要被缓存
        }
    },
    {
        path: "/home-business", // 行业考试
        name: "HomeBusiness",
        components: {
            navBar: NavBar,
            default: () => import("@/views/home/business"),
            footer: Footer
        },
        meta: {
            keepAlive: true // 需要被缓存
        }
    },
    {
        path: "/home-organization", // 机构考试
        name: "HomeOrganization",
        components: {
            navBar: NavBar,
            default: () => import("@/views/home/organization"),
            footer: Footer
        },
        meta: {
            keepAlive: true, // 需要被缓存
        }
    },
    {
        path: "/psq",
        name: "PSQ",
        component: () => import("@/views/psq"),
        meta: {
            keepAlive: true, // 需要被缓存
            auth: questionnaire.enName,
            isLogin: true
        }
    },
    {
        path: "/do-questionnaire",
        name: "DoQuestionnaire",
        component: () => import("@/views/psq/doQuestionnaire"),
        meta: {
            title: "问卷做题",
            auth: questionnaire.enName
        }
    },
    {
        path: "/course",
        name: "StudentCourse",
        component: () => import("@/views/course/course"),
        meta: {
            title: "课程",
            auth: course.enName,
            isLogin: true
        }
    },
    {
        path: "/course-play",
        name: "CoursePlay",
        component: () => import("@/views/course/course-play/course-play"),
        meta: {
            title: "课程播放",
            auth: course.enName,
            isLogin: true
        }
    },
    {
        path: "/question-result",
        name: "QuestionResult",
        component: () => import("@/views/psq/doQuestionnaireResult"),
        meta: {
            title: "问卷结果",
            auth: questionnaire.enName
        }
    },
    {
        path: "/question-analyse",
        name: "QuestionAnalyse",
        component: () => import("@/views/psq/questionnaireAnalyse"),
        meta: {
            title: "问卷分析",
            auth: questionnaire.enName
        }
    },
    {
        path: "/exam",
        name: "examList",
        component: () => import("@/views/exam"),
        meta: {
            auth: exam.enName,
            isLogin: true
        }
    },
    {
        path: "/examDetail",
        name: "examDetail",
        component: () => import("@/views/exam/exam"),
        meta: {
            auth: exam.enName,
            isLogin: true
        }
    },
    {
        path: "/question/organ",
        name: "organ",
        component: () => import("@/views/question/organ"),
        meta: {
            keepAlive: true, // 需要被缓存
            auth: questionLib.enName,
            isLogin: true
        }
    },
    {
        path: "/question/public",
        name: "public",
        component: () => import("@/views/question/public"),
        meta: {
            keepAlive: true, // 需要被缓存
            auth: questionLib.enName,
        }
    },
    {
        path: "/question/department",
        name: "department",
        component: () => import("@/views/question/department"),
        meta: {
            keepAlive: true, // 需要被缓存
            auth: questionLib.enName
        }
    },
    {
        path: "/question/allQuestions",
        name: "allQuestions",
        meta: {
            keepAlive: true, // 需要被缓存
            auth: questionLib.enName
        },
        component: () => import("@/views/question/allQuestions")
    },
    {
        path: "/publicMake",
        name: "publicMake",
        meta: {
            auth: questionLib.enName
        },
        component: () => import("@/views/publicMake")
    },
    {
        path: "/personCenter",
        name: "personCenter",
        meta: {
            auth: profile.enName,
            isLogin: true
        },
        component: () => import("@/views/personCenter/basicInfo")
    },
    {
        path: "/personCenter/member",
        name: "personCenter/member",
        meta: {
            auth: myMember.enName,
            isLogin: true
        },
        component: () => import("@/views/personCenter/member")
    },
    {
        path: "/personCenter/exam",
        name: "personCenter/exam",
        meta: {
            auth: myExam.enName,
            isLogin: true
        },
        component: () => import("@/views/personCenter/exam")
    },
    {
        path: "/personCenter/collect",
        name: "personCenter/collect",
        component: () => import("@/views/personCenter/collect"),
        meta: {
            auth: myCollect.enName,
            isLogin: true
        },
    },
    {
        path: "/personCenter/my-course",
        name: "personCenter/collect",
        component: () => import("@/views/personCenter/my-course/my-course"),
        meta: {
            auth: myCourse.enName,
            isLogin: true
        },
    },
    {
        path: "/personCenter/mark",
        name: "personCenter/mark",
        component: () => import("@/views/personCenter/mark"),
        meta: {
            auth: myTrack.enName,
            isLogin: true
        },
    },
    {
        path: "/personCenter/questionnaire",
        name: "PersonCenterQuestionnaire",
        component: () => import("@/views/personCenter/questionnaire"),
        meta: {
            auth: myQuestionnaire.enName,
            isLogin: true
        },
    },
    {
        path: "/resourceOrder",
        name: "resourceOrder",
        component: () => import("@/views/order/index"),
        meta: {
            auth: questionLib.enName,
            isLogin: true
        },
    },
    {
        path: "/alipay-result",
        name: "alipay-result",
        component: () => import("@/views/order/alipay-result"),
        meta: {
            auth: questionLib.enName,
            isLogin: true
        },
    },
    {
        path: "/gropuPaper",
        name: "gropuPaper",
        component: () => import("@/views/gropuPaper"),
        meta: {
            auth: questionLib.enName,
            isLogin: true
        },
    },
    {
        path: "/groupPractice",
        name: "groupPractice",
        component: () => import("@/views/groupPractice"),
        meta: {
            auth: exam.enName,
            isLogin: true
        },
    },
    {
        path: "/no-access",
        name: "noAccess",
        component: () => import("@/views/noAccess")
    },
    {
        path: "*",
        name: "nonePage",
        component: () => import("@/views/none")
    }
];
const router = new VueRouter({
    // mode: "history",
    // base: "/yixue/front/dist/",
    routes: [
        ...routes,
        ...baseAdminRoute,
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.path.startsWith("/home-")) {
            return {
                x: 0,
                y: 0,
                behavior: "smooth"
            }
        } else {
            // return savedPosition
            return {
                x: 0,
                y: 0
            }
        }
    }
});

// 管理员可访问白名单
const manageWhiteRouteHome = [
    "home",
    "manage-index",
    "previewExam",
    "gradingPaper",
    "examResultPaper",
    "nonePage",
    "noAccess"
];

let adminPaths = [];
// let off = config.isDev;
let off = true;
// 首页映射
const hostname = window.location.hostname
// const hostname = window.location.pathname
const [platform = "default"] = hostname.match(new RegExp(String.raw`^${Object.keys(HOME_PAGE_MAP).map(key => HOME_PAGE_MAP[key].hostKey).join("|")}`)) || []
// 不需要登录的白名单
const whiteList = ["/home-business", "/no-access", "/home-exam", "/home-organization", "/home-medicine"]

// 动态设置favicon
export function setFavicon(url) {
    if (setFavicon.isSetFavicon === true || !url) return
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = url
    document.getElementsByTagName("head")[0].appendChild(link);
    setFavicon.isSetFavicon = true
}

const setPlatform = (platform) => store.commit("setPlatform", platform)
router.beforeEach(async (to, from, next) => {
    if (window.location.hostname.includes("pxks.cqvip.com")) {
        location.href = window.location.protocol + "//kaoshi.cqvip.com"
        return next()
    }
    if (!store.state.platform) {
        setPlatform(HOME_PAGE_MAP[platform].hostKey)
    }
    if (!store.state.isLoadBingIp && !store.getters.isLogin && HOME_PAGE_MAP[platform].hostKey === "yixue") {
        const { IsIPAuthorize, Name, PlatformName, GroupUserLogo, GroupWebName } = await store.dispatch("setBindingIp")
        document.title = IsIPAuthorize ? (Name || "") + (PlatformName ? "." + PlatformName : "") : (GroupWebName || "朗润数据.") + (PlatformName ? "." + PlatformName : HOME_PAGE_MAP[platform].title)
        if (GroupUserLogo) {
            const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = GroupUserLogo
            document.getElementsByTagName("head")[0].appendChild(link);
        }
    }
    if (!store.state.isLoadBingIp && !store.getters.isLogin && HOME_PAGE_MAP[platform].hostKey !== "yixue") {
        document.title = HOME_PAGE_MAP[platform].title
    }
    if (!store.getters.isLogin && to.path !== "/" && !store.state.groupInfo.IsIPAuthorize && HOME_PAGE_MAP[platform].hostKey === "yixue") {
        if (to.meta && to.meta.auth === "question-lib-module") {
            Message.error("您不在ip范围内，请登录")
            return next({
                path: "/",
                query: to.query,
                replace: true
            })
        }
    }
    if (store.state.userInfo && Object.isObj(store.state.userInfo) && String(store.state.userInfo) !== "null") {
        const { OrganName, PlatformName } = store.state.userInfo
        const metaTitle = to.meta && to.meta.title
        document.title = OrganName + (PlatformName ? "." + PlatformName : "") + (metaTitle ? "-" + metaTitle : "")
        setFavicon(store.state.userInfo.Logo)
        if (store.state.userInfo.isManage) {
            router.setManageRoute()
        }
    }
    // 如果是进入的首页
    if (to.path === "/") {
        if (!store.getters.isLogin) {
            return next({
                path: HOME_PAGE_MAP[platform].path,
                replace: true
            })
        } else {
            if (store.state.userInfo?.isManage) {
                if (store.state.isLoadProfileRoutes === false) {
                    try {
                        const res = await store.dispatch("getPersonCenter")
                        return next({
                            path: res[0].Path,
                            replace: true,
                            query: to.query
                        })
                    } catch (e) {
                        console.log(e, "e");
                        return next({
                            path: "/no-access",
                            replace: true
                        })
                    }
                } else {
                    const profileRoutes = store.state.profileRoutes
                    if (profileRoutes.length === 0) {
                        next({
                            path: "/no-access",
                            query: to.query,
                            replace: true
                        })
                    } else {
                        if (to.path === profileRoutes[0].Path) return next()
                        return next({
                            path: profileRoutes[0].Path,
                            replace: true,
                            query: to.query
                        })
                    }
                }
            } else {
                if (store.state.isLoadNavMenu === false || store.state.isLoadProfileRoutes === false) {
                    try {
                        let navMenu = store.state.navMenu
                        if (store.state.isLoadNavMenu === false) {
                            navMenu = await store.dispatch("getNavMenu")
                        }
                        if (store.state.isLoadProfileRoutes === false) {
                            await store.dispatch("getPersonCenter")
                        }
                        return next({
                            path: navMenu[0].Path,
                            replace: true,
                            query: to.query
                        })
                    } catch (e) {
                        console.log(e, "e");
                        return next({
                            path: "/no-access",
                            replace: true
                        })
                    }
                } else {
                    const navMenu = store.state.navMenu
                    if (to.path === navMenu[0].Path) return next()
                    return next({
                        path: navMenu[0].Path,
                        replace: true,
                        query: to.query
                    })
                }
            }
        }
    }
    // 如果没有token，或者不在域名白名单之类
    // if (!store.getters.isLogin && !whiteList.includes(to.path)) {
    //     Message.error("请登录")
    //     return next({
    //         path: "/",
    //         replace: true
    //     })
    // }
    if (whiteList.includes(to.path) || to.name === "nonePage") {
        if (HOME_PAGE_MAP[platform].hostKey !== "yixue" && to.path === "/home-medicine") {
            return next({
                path: "/",
                query: to.query,
                replace: true
            })
        }
        return next()
    }
    if (store.state.userInfo?.isManage) {
        if (store.state.isLoadProfileRoutes === false) {
            try {
                await store.dispatch("getPersonCenter")
                return next({
                    ...to,
                    replace: true
                })
            } catch (e) {
                return next({
                    path: "/no-access",
                    replace: true
                })
            }
        }
        let fullPath = to.path;
        if (fullPath.endsWith("/")) fullPath = fullPath.slice(0, fullPath.length - 1)
        let canNext = adminPaths.some(el => el === fullPath)
        if (canNext) {
            next()
        } else {
            if (manageWhiteRouteHome.includes(to.name)) {
                next()
            } else {
                alert("管理员仅支持访问管理后台");
                next(false);
            }
        }
    } else {
        if (to.path.startsWith("/manage")) {
            return next({
                path: "/no-access",
                replace: true
            })
        } else {
            if (store.state.isLoadNavMenu === false) {
                try {
                    await store.dispatch("getNavMenu")
                    return next({
                        path: to.path,
                        query: to.query,
                        replace: true
                    })
                } catch (e) {
                    return next({
                        path: "/no-access",
                        replace: true
                    })
                }
            } else {
                let navMenu = [...store.state.navMenu]
                if (store.getters.isLogin) {
                    const res = await store.dispatch("getPersonCenter")
                    navMenu.push(...res)
                }
                const navMenus = navMenu.map(item => codeMapModules[item.Code].enName)
                if (navMenus.includes(to.meta && to.meta.auth)) {
                    return next()
                } else {
                    return next({
                        replace: true,
                        path: "/no-access"
                    })
                }
            }
        }
    }
});
// 计算管理员路由表
router.setManageRoute = function () {
    if (router.setManageRoute.isLoad === true) return
    let paths = localStorage.getItem("user_modular");
    if (!paths) return;
    paths = paths.split("$$");
    adminPaths = paths;

    function addRoutes(children, targetArr, basePath) {
        for (let child of children) {
            child = Object.assign({}, child);
            let bp;
            let added = false;
            if (child.path.indexOf("/") === 0 || child.path === "") {
                bp = basePath + child.path;
            } else {
                bp = basePath + "/" + child.path;
            }
            if (paths.includes(bp)) {
                targetArr.push(child);
                added = true;
            }
            if (child.children) {
                let target = [];
                addRoutes(child.children, target, bp);
                if (target.length > 0) {
                    child.children = target;
                    if (added === false) targetArr.push(child);
                }
            }
        }
    }

    let routes = [];
    addRoutes(baseAdminRoute, routes, "");
    console.log(routes, 'codeMapModules');
    router.adminRoutes = routes;
    router.setManageRoute.isLoad = true
    // router.adminRoutes = baseAdminRoute;
};
// 从远程服务器加载路由权限
router.setManageRouteOfServer = function () {
    return new Promise((resolve, reject) => {
        function work(children, result) {
            children.forEach(el => {
                result.push(el.Path)
                if (el.children) {
                    work(el.children, result)
                }
            })
        }

        getModularByUserId().then(r => {
            let paths = []
            work(r, paths)
            paths = paths.join("$$")
            localStorage.setItem("user_modular", paths)
            router.setManageRoute()
            resolve(paths)
        }).catch(e => reject(e))
    })
}

export default router;
